import { matchRoutePath } from '../../../../../shared/frontend/libs/router/router-helpers';
import { namedRoutes } from '../bundles/routes';
import { LOCATION_CHANGE } from '../../../../../shared/frontend/libs/router/redux-store';
import { UPDATE_MYTHIC_PLUS_CUTOFFS } from '../actions/mythicPlusCutoffsActions';
import { TAction } from '../../../../../shared/frontend/scripts/actions/types/action';

export default function mythicPlusCutoffsReducer(state: Partial<any> = {}, action: TAction<any>): Partial<any> {
  switch (action.type) {
    case UPDATE_MYTHIC_PLUS_CUTOFFS: {
      return {
        ...state,
        ...action.payload
      };
    }
    case LOCATION_CHANGE: {
      if (action.payload.isFirstRendering) {
        return state; // server render may have pre-populated state, so we don't want to nuke it
      }
      const match = matchRoutePath(
        { path: namedRoutes.MythicPlusCutoffs, end: true },
        action.payload.location.pathname
      );
      if (
        match &&
        [state.ui, state.summaryUi].some(
          (selection) => selection?.season === match.params.season && selection?.region === match.params.region
        )
      ) {
        return state;
      }
      return {};
    }
    default:
      return state;
  }
}
